<h1 class="h3 mb-2 text-gray-800">Casos</h1>

<div class="card shadow mb-4">
  <div class="card-header py-3">
    <h6 class="m-0 font-weight-bold text-primary">Archivos del caso</h6>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-4 offset-4">
            <div class="form-group" *ngIf="archivoExiste('foto-superior')">
              <label>
                Foto Superior
              </label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('foto-superior')}}" target="_blank"><img
                    src="{{getImageUrl('foto-superior')}}" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-group" *ngIf="archivoExiste('foto-derecha')">
              <label>Foto Lateral Der</label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('foto-derecha')}}" target="_blank"><img
                    src="{{getImageUrl('foto-derecha')}}" /></a>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group" *ngIf="archivoExiste('frente-intraoral')">
              <label>Frente Intraoral</label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('frente-intraoral')}}" target="_blank"><img
                    src="{{getImageUrl('frente-intraoral')}}" /></a>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group" *ngIf="archivoExiste('foto-izquierda')">
              <label>Foto Lateral Izq</label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('foto-izquierda')}}" target="_blank"><img
                    src="{{getImageUrl('foto-izquierda')}}" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4 offset-4">
            <div class="form-group" *ngIf="archivoExiste('foto-inferior')">
              <label>Foto Inferior</label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('foto-inferior')}}" target="_blank"><img
                    src="{{getImageUrl('foto-inferior')}}" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-group" *ngIf="archivoExiste('frente-facial')">
              <label>Frente Facial</label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('frente-facial')}}" target="_blank"><img
                    src="{{getImageUrl('frente-facial')}}" /></a>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group" *ngIf="archivoExiste('frente-facial-sonrisa')">
              <label>Frente Facial Sonrisa</label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('frente-facial-sonrisa')}}" target="_blank"><img
                    src="{{getImageUrl('frente-facial-sonrisa')}}" /></a>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group" *ngIf="archivoExiste('perfil-facial')">
              <label>Perfil facial</label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('perfil-facial')}}" target="_blank"><img
                    src="{{getImageUrl('perfil-facial')}}" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group" *ngIf="archivoExiste('comprobante-inicial')">
              <label>
                Comprobante de pago inicial
              </label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('comprobante-inicial')}}" target="_blank"><img
                    src="{{getImageUrl('comprobante-inicial')}}" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="caso.plantratamiento?.id != 0">
          <div class="col-6">
            <div class="form-group" *ngIf="archivoExiste('rad-lateral')">
              <label>
                Radiografía lateral
              </label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('rad-lateral')}}" target="_blank"><img
                    src="{{getImageUrl('rad-lateral')}}" /></a>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group" *ngIf="archivoExiste('rad-panoramica')">
              <label>
                Radiografía panorámica
              </label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('rad-panoramica')}}" target="_blank"><img
                    src="{{getImageUrl('rad-panoramica')}}" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row"
          *ngIf="archivoExiste('stl-1')||archivoExiste('stl-2')||archivoExiste('stl-3')||archivoExiste('stl-4')||archivoExiste('stl-5')">
          <div class="col-12">
            <div>
              <label>Archivos STL</label>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="caso.plantratamiento?.id != 0">
          <div class="col-4" *ngIf="archivoExiste('stl-1')">
            <div>
              <a [href]="getFileUrl('stl-1', 'stl')" target="_blank">Ver STL 1</a>
            </div>
          </div>
          <div class="col-4" *ngIf="archivoExiste('stl-2')">
            <div>
              <a [href]="getFileUrl('stl-2', 'stl')" target="_blank">Ver STL 2</a>
            </div>
          </div>
          <div class="col-4" *ngIf="archivoExiste('stl-3')">
            <div>
              <a [href]="getFileUrl('stl-3', 'stl')" target="_blank">Ver STL 3</a>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="caso.plantratamiento?.id != 0">
          <div class="col-4" *ngIf="archivoExiste('stl-4')">
            <div>
              <a [href]="getFileUrl('stl-4', 'stl')" target="_blank">Ver STL 4</a>
            </div>
          </div>
          <div class="col-4" *ngIf="archivoExiste('stl-5')">
            <div>
              <a [href]="getFileUrl('stl-5', 'stl')" target="_blank">Ver STL 5</a>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="caso.plantratamiento?.id != 0">
          <div class="col-12" *ngIf="archivoExiste('pdf-caso')">
            <div>
              <label>PDF del Caso</label>
            </div>
            <div>
              <a [href]="getFileUrl('pdf-caso', 'pdf')" target="_blank">Ver archivo</a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group" *ngIf="archivoExiste('comprobante-tratamiento')">
              <label>
                Comprobante de tratamiento
              </label>
              <div>
                <a class="caso-foto" href="{{getImageUrl('comprobante-tratamiento')}}" target="_blank"><img
                    src="{{getImageUrl('comprobante-tratamiento')}}" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="row"
          *ngIf="caso.status == estadosCaso.PAGO_TRATAMIENTO_REALIZADO || caso.status == estadosCaso.PAGO_TRATAMIENTO_COMPROBADO|| caso.status == estadosCaso.TRATAMIENTO_APROBADO_PAGO_SOLICITADO || caso.status == estadosCaso.CASO_ENTREGADO_Y_APROBADO || caso.status == estadosCaso.PAGO_TRATAMIENTO_ERRONEO || caso.status == estadosCaso.CASO_ENTREGADO_RECHAZADO">
          <div class="col-12">
            <label>Documento de aprobación aceptado</label>
            <app-textoaceptacion></app-textoaceptacion>

          </div>
        </div>
        <div class="form-group">
          <a [routerLink]="'/casos/'+caso.id+'/verpaciente'" class="btn btn-link">Volver</a>
        </div>
      </div>
    </div>
  </div>
</div>